import React from 'react';
import ReactDOM from 'react-dom/client';
import { EngineCommercialA4Print } from '@/components/print/EngineCommercialPrints';
import type { PrintColumn } from '@/print-engine';
import type { SimplePrintLine } from '@/print-engine/adapters/simple-document';

export type OpenEngineCommercialPrintInput = {
  title: string;
  documentNumber: string;
  partyName?: string;
  metaLines?: Array<{ label: string; value: string }>;
  introText?: string;
  columns: PrintColumn[];
  lines: SimplePrintLine[];
  finals?: Array<{ id: string; heightPx: number; keepTogetherWithNext?: boolean }>;
  finalBlocks?: Record<string, React.ReactNode>;
  docType?: string;
  letterhead?: boolean;
};

/** Mount A4 commercial print overlay (shared pagination engine). */
export function openEngineCommercialPrint(input: OpenEngineCommercialPrintInput): void {
  const mainContent = document.querySelector('.ant-layout-content') as HTMLElement | null;
  const printContainer = document.createElement('div');
  printContainer.id = 'print-container';
  document.body.appendChild(printContainer);
  if (mainContent) mainContent.style.display = 'none';

  let root: ReactDOM.Root | null = null;
  const cleanup = () => {
    root?.unmount();
    if (printContainer.parentNode) document.body.removeChild(printContainer);
    if (mainContent) mainContent.style.display = '';
    window.removeEventListener('afterprint', cleanup);
  };

  root = ReactDOM.createRoot(printContainer);
  root.render(
    <EngineCommercialA4Print
      docType={input.docType}
      title={input.title}
      documentNumber={input.documentNumber}
      partyName={input.partyName}
      metaLines={input.metaLines}
      introText={input.introText}
      columns={input.columns}
      lines={input.lines}
      finals={input.finals}
      finalBlocks={input.finalBlocks}
      letterhead={input.letterhead}
      onClose={cleanup}
    />
  );
  window.addEventListener('afterprint', cleanup);
}
